import React from 'react';
import { createRoot } from 'react-dom/client';
import * as PSLib from "poolside-js-lib";
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AppContextProvider } from './components/AppContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap/dist/react-bootstrap.min.js';
import './css/App.css';
import 'react-bootstrap-multiselect/css/bootstrap-multiselect.css';

if (process.env.REACT_APP_LOG_LEVEL) {
    PSLib.setLogLevel(process.env.REACT_APP_LOG_LEVEL);
}

const container = document.getElementById("app");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <React.StrictMode>
        <AppContextProvider>
            <App />
        </AppContextProvider>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
